import {Action, Reducer} from "redux";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../index";

export interface StoreSelectionPopupState {
    open: boolean
}

interface SetStoreSelectionPopupState extends Action {
    type: "@appigo-retailer-ui/set-store-selection-popup-status"
    open: boolean
}

function isSetStoreSelectionPopUpState(action: Action): action is SetStoreSelectionPopupState {
    return action.type === "@appigo-retailer-ui/set-store-selection-popup-status"
}

function setStoreSelectionPopUpState(open: boolean): SetStoreSelectionPopupState {
    return {
        open,
        type: "@appigo-retailer-ui/set-store-selection-popup-status"
    }
}

export const storeSelectionPopUpReducer: Reducer<StoreSelectionPopupState, SetStoreSelectionPopupState> = (state = { open: false }, action) =>
    isSetStoreSelectionPopUpState(action) ? {open: action.open} : state

export function useStoreSelectionPopUp(): [boolean, (open: boolean) => void] {
    const dispatch = useDispatch();
    return [
        useSelector<RootState, StoreSelectionPopupState>(state => state.uiState.storeSelectionPopUp).open,
        open => dispatch(setStoreSelectionPopUpState(open))
    ]
}